import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersByCountryQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsUsersByCountryTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [limit, setLimit] = useState(10);

  const { data, loading, error } = useAnalyticsUsersByCountryQuery({
    variables: { filter: filter as never, limit },
  });

  const rows = (data?.analyticsUsers.usersByCountry ?? []).map((row) => [
    row.countryCode,
    formatNumber(row.users),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.users.tableByCountry")}
      columns={[
        { name: t("analytics.users.columnCountry") },
        { name: t("analytics.users.columnUsers") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      limit={limit}
      setLimit={setLimit}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.UsersByCountryType}
          filter={filter}
        />
      }
    />
  );
};
